import 'components/onboarding/form-components/style.scss';
import { TextFieldControl } from 'components/common/textField';
import { Button } from 'shared-components';
import { FC } from 'react';

export const OnboardForm: FC = () => {
  return (
    <div className="onboard-form">
      <div className="heading-text-area">
        <p className="text-bold">{`Welcome! Let's Begin`}</p>
      </div>
      <div className="onboarding-fields">
        <div className="onboarding-field">
          <TextFieldControl
            name="Name"
            rules={{ required: 'This field is required' }}
            className="onboarding-input"
            placeholder="Enter Organization Name"
            fixedSize="md"
            label="Organization Name"
          />
        </div>
      </div>

      <div className="button-field">
        <Button
          variant="reliant"
          className="onboarding-continue-button mt-8"
          type="submit"
          label="CONTINUE"
        />
      </div>
    </div>
  );
};
